import { observable, action, runInAction } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/xiu_yan/relatedCasesApi'
import { hasSomeKey } from '@hlj/hlj-utils'
import indexStore from '../store'
import { message } from 'hljd'

class Store extends BaseStore {
  constructor(id) {
    super()
    this.set_meal_id = id
  }

  $pagination = {
    showQuickJumper: false,
    pageSize: 20
  }
  $listApi = Api.case_list
  $getParams = () => {
    const { params, $params } = this
    return {
      ...$params,
      ...params
    }
  }

  params = {}
  setParams = values => {
    this.params = values ? { ...this.params, ...values } : {}
    if (!hasSomeKey(values, ['title'])) {
      this.$getList(1)
    }
  }

  @observable length = 0
  @action
  getTotalNum = async () => {
    let params = {
      title: '',
      page: 1,
      per_page: 20
    }
    let {
      data: { total_count }
    } = await Api.case_list(params)
    runInAction(() => {
      this.length = +total_count
    })
  }

  @observable visible = false
  @action
  showVisible = () => {
    indexStore.getExampleUse()
    this.visible = true
  }

  @action
  add = async () => {
    const { set_meal_id, $selectedRowKeys, length } = this
    let uselength = indexStore.useExample.length
    if (uselength == length) {
      message.warning('提示：当前无可添加的案例，请先新增案例！')
    } else if ($selectedRowKeys.length == 0) {
      message.warning('提示：请选择案例！')
    } else {
      let { success } = await Api.add_relative_example({
        set_meal_id,
        example_ids: $selectedRowKeys.join()
      })
      if (success) {
        message.success('操作成功！')
        this.cancel()
        indexStore.$getList(1)
      }
    }
  }

  @action
  cancel = () => {
    this.visible = false
    this.setParams()
  }
}

export default Store
